import actions from './actions';

const initState = {
  brandInfo: {},
  brands: {
    data: [],
  },
  loading: false,
  brandDeleted: false,
  message: null,
  status: null,
};

export default function fetchBrandsReducer(state = initState, action) {
  switch (action.type) {
    case actions.SEARCH_BRANDS_REQUESTED:
    case actions.FETCH_BRANDS_REQUESTED:
      return {
        ...state,
        brands: {
          data: [],
        },
        loading: true,
      };
    case actions.SEARCH_BRANDS_SUCCESS:
    case actions.FETCH_BRANDS_SUCCEEDED:
      return {
        ...state,
        brands: action.brands,
        loading: false,
      };
    case actions.SEARCH_BRANDS_FAILED:
    case actions.FETCH_BRANDS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_BRAND_REQUESTED:
      return {
        ...state,
        brandInfo: {},
        loading: true,
      };
    case actions.FETCH_BRAND_SUCCEEDED:
      return {
        ...state,
        brandInfo: action.brand,
        loading: false,
      };
    case actions.FETCH_BRAND_FAILED:
      return {
        ...state,
        loading: false,
      };

    case actions.DELETE_BRAND_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.DELETE_BRAND_SUCCEEDED:
      return {
        ...state,
        loading: false,
        brandDeleted: true,
        message: 'Brand deleted successfully!',
        status: 200,
      };
    case actions.DELETE_BRAND_FAILED:
      return {
        ...state,
        loading: false,
        message: action?.error?.message,
        status: action?.error?.status,
      };
    case actions.CLEAR_ALERT_MESSAGE:
      return {
        ...state,
        message: null,
        status: null,
      };
    default:
      return state;
  }
}
